import React, { memo, useState, useRef, useEffect } from "react";
import { countryCodes } from "../../../constants/countryCodes";
import { handleNumberInputWithoutDecimal } from "../../../constants/globalFunction";
import { FaChevronDown, FaSearch } from "react-icons/fa";
import "./PhoneInput.css";

const PhoneInput = ({
  code,
  onChangeText,
  value,
  label,
  labelStyle,
  onChangeCode,
  required = false,
  maxLength,
  placeholder,
  inputContainerStyle,
  inputStyle,
  editable = true,
  error,
  disabled = false,
  containerStyle,
  className,
}) => {
  const [showCodePicker, setShowCodePicker] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [countryCode, setCountryCode] = useState(() => {
    const matched = countryCodes.find((item) => item.dial_code === code);
    return matched || { flag: "🇮🇳", dial_code: "+91", name: "India" }; // default fallback
  });

  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCodePicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onFlagPress = () => {
    if (editable && !disabled) {
      setShowCodePicker(!showCodePicker);
    }
  };

  const onSelect = (selectedCountry) => {
    onChangeCode(selectedCountry);
    setCountryCode(selectedCountry);
    setShowCodePicker(false);
    setSearchTerm("");
  };

  const filteredCountries = countryCodes.filter(
    (country) =>
      country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      country.dial_code.includes(searchTerm)
  );



  return (
    <div className="phone-input-wrapper">
      {label && (
        <label className="phone-input-label">
          {label}
          {required && <span className="phone-input-required-text">*</span>}
        </label>
      )}

      <div className="phone-input-relative-container">
        <div className={`phone-input-container ${error ? 'error' : ''} ${(!editable || disabled) ? 'disabled' : ''} ${className || ''}`} style={containerStyle}>
          <div
            className={`phone-input-flag-container ${(!editable || disabled) ? 'disabled' : ''}`}
            onClick={onFlagPress}
          >
            <span className="phone-input-flag">{countryCode.flag}</span>
            <FaChevronDown size={16} color="var(--color-primary)" />
          </div>

          <input
            className="phone-input-input"
            type="tel"
            value={value}
            onChange={(e) => onChangeText(handleNumberInputWithoutDecimal(e.target.value))}
            maxLength={countryCode?.dial_code === "+91" ? 10 : 15}
            placeholder={placeholder}
            disabled={!editable || disabled}
          />
        </div>

        {showCodePicker && (
          <div ref={dropdownRef} className="phone-input-dropdown">
            <div className="phone-input-search-container">
              <div className="phone-input-search-wrapper">
                <FaSearch
                  size={14}
                  color="var(--color-grayText)"
                  className="phone-input-search-icon"
                />
                <input
                  type="text"
                  placeholder="Search country..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="phone-input-search-input with-icon"
                />
              </div>
            </div>

            <div className="phone-input-country-list">
              {filteredCountries.map((country) => (
                <div
                  key={country.code}
                  className="phone-input-country-item"
                  onClick={() => onSelect(country)}
                >
                  <span className="phone-input-country-flag">{country.flag}</span>
                  <div className="phone-input-country-info">
                    <div className="phone-input-country-name">{country.name}</div>
                    <div className="phone-input-country-code">
                      {country.dial_code}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {error && <div className="phone-input-error">{error}</div>}
    </div>
  );
};

export default memo(PhoneInput);
